import React from 'react';
import { fmt } from './fmt';

/**
 * Where a registered person's month came from, store by store (help days included).
 * Rendered only when the API split the month over more than one store
 * (`GET /dashboard/kpis` → `breakdown`, owner request 2026-09-30, mockup scene 2).
 * `onDark` = inside the green Home hero.
 */
export default function StoreBreakdown({ breakdown, onDark = false }) {
  if (!Array.isArray(breakdown) || breakdown.length < 2) return null;
  const color = onDark ? 'rgba(255,255,255,.85)' : 'var(--slate)';
  return (
    <div
      className="store-breakdown"
      style={{
        display: 'grid',
        gap: 2,
        marginTop: 8,
        padding: '6px 10px',
        borderRadius: 10,
        background: onDark ? 'rgba(255,255,255,.12)' : 'var(--bg-sunken)',
        fontSize: 11,
        color,
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {breakdown.map((b) => (
        <span key={b.store} style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
          <span>
            {b.store}
            {b.main ? '' : '（応援）'}
          </span>
          <b style={{ color: onDark ? '#fff' : 'var(--ink)' }}>
            {fmt('currency', b.total_sales)}
            {b.customer_count != null ? ` · ${b.customer_count}名` : ''}
          </b>
        </span>
      ))}
    </div>
  );
}
